import React from 'react';
import { FaStar, FaCalendarAlt } from 'react-icons/fa';
import { Candidate } from './types/Candidate'; 

interface CandidateCardProps {
  candidate: Candidate;
}

const CandidatoCard: React.FC<CandidateCardProps> = ({ candidate }) => {
  return (
    <div className="bg-white rounded-lg p-3 flex justify-between items-center shadow">
      <div className="flex items-center">
        <img
          src={candidate.image || 'https://via.placeholder.com/40'}
          alt="profile"
          className="w-10 h-10 rounded-full mr-3"
        />
        <div>
          <p className="font-bold">{candidate.name}</p>
          <div className="flex items-center">
            {Array.from({ length: candidate.stars }).map((_, i) => (
              <FaStar key={i} className="text-yellow-400" />
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <FaCalendarAlt className="text-gray-400 mr-2" />
        <span>{candidate.date}</span>
      </div>
    </div>
  );
};

export default CandidatoCard;
